import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';

// Reaxl Components
import Accordion from '../Accordion/index.js';
import AccordionPanel from '../AccordionPanel/index.js';
import ListColumns from '../ListColumns/index.js';
function CollapsibleListColumns(_ref) {
  let {
    items = [],
    title,
    collapsed = false,
    render,
    component,
    className,
    xs = 1,
    sm = 3,
    md,
    lg,
    bordered,
    condensed,
    striped,
    hover,
    titleComponentClass = 'div',
    ...rest
  } = _ref;
  const sizes = {
    xs
  };
  let prevSize = xs;
  if (sm && sm !== prevSize) {
    sizes.sm = sm;
    prevSize = sm;
  }
  if (md && md !== prevSize) {
    sizes.md = md;
    prevSize = md;
  }
  if (lg && lg !== prevSize) {
    sizes.lg = lg;
  }
  function renderItemColumns() {
    return /*#__PURE__*/React.createElement(ListColumns, Object.assign({
      className: "list-unstyled",
      items: items,
      render: render,
      component: component,
      bordered: bordered,
      condensed: condensed,
      striped: striped,
      hover: hover,
      key: "listColumn"
    }, sizes));
  }
  function renderAccordion() {
    return /*#__PURE__*/_jsx(Accordion, {
      bsStyle: "primary"
    }, void 0, /*#__PURE__*/_jsx(AccordionPanel, {
      title: title,
      eventKey: "panel1"
    }, void 0, renderItemColumns()));
  }
  function renderTitle() {
    const ComponentClass = titleComponentClass;
    return title && /*#__PURE__*/_jsx(ComponentClass, {
      className: "text-bold"
    }, "title", title);
  }
  function renderDefault() {
    return /*#__PURE__*/_jsx("div", {
      className: "margin-vertical-5"
    }, void 0, renderTitle(), renderItemColumns());
  }
  function renderSection() {
    return collapsed ? renderAccordion() : renderDefault();
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "collapsibleListColumns",
    className: className
  }, rest), renderSection());
}
export default CollapsibleListColumns;